// RCS external-client portal has a single auth mechanism: email + password.
// There is no Jasso SSO here, so an unauthenticated user is always sent to
// this app's own login page (never to the JBM Jasso URL — that would log the
// user into the JBM portal and surface JBM data).
export function redirectToLogin() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
  localStorage.removeItem("username");
  localStorage.removeItem("jassoVerified");
  window.location.href = `${process.env.REACT_APP_URL}/auth/login`;
}
